export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-gift-line',
      title: '先行特典',
      items: [
        'Ver.0の開始案内を最優先で受け取る',
        '気づいた点を送れる（反映は可能な範囲）',
        '更新情報をLINEで受け取る'
      ]
    },
    {
      icon: 'ri-video-line',
      title: '投稿者（動画ログ用）',
      items: [
        '自分の「食のログ」を動画で残す',
        '初期投稿者バッジ（予定）',
        '投稿ガイド/提出がLINEで完結'
      ]
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="text-4xl font-bold text-center text-[#111111] mb-16">
          参加すると何ができる？
        </h2>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1"
              style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-5xl text-[#EDD92A]`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-[#111111] mb-6">
                {benefit.title}
              </h3>

              {/* Items List */}
              <ul className="space-y-4">
                {benefit.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-[#EDD92A] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span className="text-base text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Section CTA */}
        <div className="text-center">
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#EDD92A] text-black font-bold px-8 py-4 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 6px 16px rgba(0,0,0,0.15)' }}
          >
            LINEで先行テスター/投稿者登録（無料）
          </a>
        </div>
      </div>
    </section>
  );
}
